import { IDmHinhThucThi } from "../../../model/response/category/IDmHinhThucThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHinhThucThiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmHinhThucThi[],
  LOAD_ERROR: "",
};

export const eHinhThucThiActionIds = generateActionTypeIds(
  eHinhThucThiActionsObj,
  "HINH_THUC_THI"
);

export type IHinhThucThiActionTypes = IGenericActionType<
  typeof eHinhThucThiActionsObj,
  "HINH_THUC_THI"
>;
